import { useQuery } from '@apollo/client';
import {
  Company,
  GET_COMPANY,
  GET_INVESTOR_INSIGHTS,
  InvestorInsights,
} from '@frontend/data-access';
import { getLinkLabel } from '@frontend/shared/util';
import { Col, Modal, Spin } from 'antd';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';

import EditInsightsCard, {
  InsightItemType,
} from '../components/edit-insights-card';

type ActionTypes =
  | 'PRODUCT_SERVICE_INFORMATION'
  | 'CUSTOMER_ACQUISITION'
  | 'FINANCIAL'
  | 'QUALITY_OF_REVENUES'
  | 'FINANCING_HISTORY'
  | 'FUNDRAISE'
  | 'OTHER';

const InvestorInsights = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const id = Number(router.query['companyId']);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [actionType, setActionType] = useState<ActionTypes>();

  const { data } = useQuery<{ company: Company }>(GET_COMPANY, {
    variables: { id: id },
  });

  const { data: dataInsight, loading } = useQuery<{
    retrieveInvestorInsight?: InvestorInsights;
  }>(GET_INVESTOR_INSIGHTS, {
    variables: {
      companyId: id,
    },
  });

  const handleClose = () => {
    setActionType(undefined);
    setIsModalOpen(false);
  };

  const renderAction = () => {
    if (data)
      switch (actionType) {
        case 'PRODUCT_SERVICE_INFORMATION':
          break;
        case 'CUSTOMER_ACQUISITION':
          break;
        case 'FINANCIAL':
          break;
        case 'QUALITY_OF_REVENUES':
          break;
        case 'FINANCING_HISTORY':
          break;
        case 'FUNDRAISE':
          break;
        case 'OTHER':
          break;
        default:
          break;
      }
    return <div />;
  };

  const renderTitle = () => {
    return t('edit_title', {
      title: getLinkLabel(actionType?.toLowerCase() as string),
    });
  };

  const items: InsightItemType[] = [
    {
      title: t('product_service_information'),
      items: ['information'],
    },
    {
      title: t('customer_acquisition'),
      items: ['partners'],
    },
    {
      title: t('financials'),
      items: [
        'customerAmount',
        'totalTeamSize',
        'techEmployees',
        'salesEmployees',
      ],
    },
    {
      title: t('quality_of_revenues'),
      items: ['revenuePlan'],
    },
    {
      title: t('financing_history'),
      items: ['totalAmountRaised', 'currentInvestors'],
    },
    {
      title: t('fundraise'),
      items: [
        'targetFundRaisingAmount',
        'fundingType',
        'fundUsage',
        'closingDate',
      ],
    },
    {
      title: t('other'),
      items: ['approvals'],
    },
  ];

  if (loading)
    return (
      <div className="text-center p-5">
        <Spin />
      </div>
    );

  return (
    <div>
      {t('update_fields')}
      <br />
      These fields are visible only to your institution profile manager and
      Ideation Bridge admin.
      <div className="mt-8">
        <Col className="space-y-6">
          {items.map((item) => (
            <EditInsightsCard
              key={item.title}
              item={item}
              data={dataInsight?.retrieveInvestorInsight as InvestorInsights}
            />
          ))}
        </Col>
        <Modal
          title={renderTitle()}
          open={isModalOpen}
          onCancel={handleClose}
          width={800}
          footer={false}
        >
          {renderAction()}
        </Modal>
      </div>
    </div>
  );
};

export default InvestorInsights;
